import React, { SetStateAction, useEffect, useState } from "react";
import { PageTemplate } from "../../../../shared/layout/PageTemplate";
import { ContentEditableEvent } from "react-simple-wysiwyg";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../../../shared/toasters/toasters";
import { useSelector } from "react-redux";
import { IAllStates } from "../../../../store/rootReducer";
import { ProductsService } from "../../../products/service";
import { IProducts, IProductsList } from "../../../products/dto/IProducts";
import { BaseDataActions } from "../../../products/baseData/components/BaseDataActions";
import { ActualFileObject } from "filepond";
import { SingleValue } from "react-select";
import DataFromExcel from "./DataFromExcel";
import Select from "react-select";
import { themeSelect } from "../../../../shared/components/Select2";
import GalleryCardPreview from "../../../../shared/gallery/GalleryCardPreview";
import ImageContainer from "../../../../shared/gallery/ImageContainer";

export const EditImportedBaseData = () => {
  const [currentProduct, setCurrentProduct] = useState<IProducts>();
  const [files, setFiles] = useState<ActualFileObject[]>([]);
  const [documentFiles, setDocumentFiles] = useState<ActualFileObject[]>([]);
  const [videoFiles, setVideoFiles] = useState<ActualFileObject[]>([]);
  const tab = "BASE_DATA";

  const [currentStatus, setCurrentStatus] = useState({});
  const categories = useSelector((state: IAllStates) => state.category);
  const { id }: any = useParams();
  const { state: pagination }: any = useLocation();
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [currentTranslations, setCurrentTranslations] = useState<any>({
    en: {
      photos: [],
      documents: [],
      videos: [],
    },
    de: {
      photos: [],
      documents: [],
      videos: [],
    },
    fr: {
      photos: [],
      documents: [],
      videos: [],
    },
    it: {
      photos: [],
      documents: [],
      videos: [],
    },
  });
  const { productStatus } = useSelector((state: IAllStates) => state.enums);
  const changeHandler = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | ContentEditableEvent
    >
  ) => {
    // @ts-ignore
    const { value, name } = event.target;
    setCurrentProduct((prev: any) => ({ ...prev, [name]: value }));
  };
  useEffect(() => {
    id &&
      tab &&
      ProductsService.getProductById(+id, tab)
        .then((response) => {
          setCurrentProduct(response);
        })
        .catch((error) => {
          ErrorToast(error);
          navigate(-1);
        });
  }, [id]);

  const navContent = () => {
    navigate(`/app/pending-products/imported/content/${id}`, {
      state: pagination,
    });
  };
  const navAttributes = () => {
    navigate(`/app/pending-products/imported/attributes/${id}`, {
      state: pagination,
    });
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const formData = new FormData();
    for (let i = 0; i < files?.length; i++) {
      formData.append("files", files[i]);
    }
        for (let i = 0; i < documentFiles?.length; i++) {
      formData.append("documents", documentFiles[i]);
    }
    for (let i = 0; i < videoFiles?.length; i++) {
      formData.append("videos", videoFiles[i]);
    }
    formData.append(
      "body",
      JSON.stringify({
        ...currentProduct,
        category: Number(currentProduct?.category)
          ? currentProduct?.category
          : (currentProduct?.category as any)?.id,
        brand: Number(currentProduct?.brand)
          ? currentProduct?.brand
          : (currentProduct?.brand as any)?.id,
      })
    );
    ProductsService.updateProductById(formData, Number(id))
      .then((response) => {
        // navigate('/app/pending-products/imported', { state: (location.state as any)?.pagination });
        SuccessToast(`${t("toasts.successfully_updated")} ${response.title}`);
        // navigate("/app/pending-products/imported", { state: { pagination: pagination?.pagination ?? {} } });
      })
      .catch((error) => ErrorToast(error));
  };
  const handleClose = () => {
    navigate("/app/pending-products/imported", {
      state: (location.state as any)?.pagination,
    });
    // navigate("/app/pending-products/imported", { state: { pagination: pagination?.pagination ?? {} } });
  };
  const handleSelectMainCategory = (
    selectedSingle: SingleValue<{ label: string; value: number }>,
    inputKey: string
  ) => {
    setCurrentProduct((prev: any) => ({
      ...prev,
      [inputKey]: selectedSingle?.value,
    }));
  };
  const handleSelectStatus = (
    selectedSingle: SingleValue<{ label: string }>,
    inputKey: string
  ) => {
    setCurrentStatus({ [inputKey]: selectedSingle?.label });
  };
  const handleChangeStatus = (event: React.FormEvent) => {
    event.preventDefault();
    ProductsService.updateProductStatus(
      currentStatus,
      Number(currentProduct?.id)
    )
      .then((response) => {
        SuccessToast(`${t("products.change_staus")} ${response?.status}`);
        if (response?.status === "PENDING") {
          navigate(1);
        } else {
          navigate(-1);
        }
      })
      .catch((error) => ErrorToast(error));
  };
  return (
    // <PageTemplate title={`${t("side_bar.imported_product")}`}>
    <>
      <div className="col-md-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <div className="d-flex align-itmes-end">
            <ul className="nav nav-pills nav-fill">
              <li className="nav-item">
                <span className="nav-link active">
                  {t("products.base_data_update")}
                </span>
              </li>
              <li onClick={() => navAttributes()}>
                <span className="nav-link cursor-pointer text-dark">
                  {t("products.attributes_update")}
                </span>
              </li>
              {/* <li>
                <Link
                  className="nav-link"
                  to={`/app/pending-products/imported/attributes/${id}`}
                >
                  {t("products.attributes_update")}
                </Link>
              </li> */}
              <li onClick={() => navContent()}>
                <span className="nav-link cursor-pointer text-dark">
                  {t("products.content_update")}
                </span>
              </li>
            </ul>
          </div>
          {currentProduct?.status && (
            <div className="d-flex">
              <Select
                className="react-select-field"
                theme={themeSelect}
                options={productStatus?.map((status) => ({
                  label: status ?? "-",
                  value: status,
                }))}
                defaultValue={{
                  label: currentProduct?.status,
                  value: currentProduct?.status,
                }}
                key={currentProduct?.id}
                onChange={(e: any) => {
                  handleSelectStatus(
                    e as SingleValue<{ label: string }>,
                    "productStatus"
                  );
                }}
              />
              <button
                className="btn btn-secondary btn-sm ms-2"
                onClick={handleChangeStatus}
              >
                {t("products.change_staus")}
              </button>
            </div>
          )}
          <>
            <button
              className="btn btn-primary d-flex align-items-center me-2"
              data-bs-toggle="offcanvas"
              data-bs-target={`#offcanvasRight-${id}`}
              aria-controls={`offcanvasRight-${id}`}
            >
              <i className="ri-information-line me-1" />
              {`${t("global.info")}`}
            </button>
            <div
              className="offcanvas offcanvas-end"
              id={`offcanvasRight-${id}`}
              aria-labelledby="offcanvasRightLabel"
            >
              <div className="offcanvas-header">
                <h5 id="offcanvasRightLabel">{t("products.info_excel")}</h5>
                <button
                  type="button"
                  className="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div className="offcanvas-body">
                <DataFromExcel
                  currentExcelProductId={id as unknown as number}
                />
              </div>
            </div>
          </>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-start">
        <button
          onClick={() => handleClose()}
          className="btn btn-info d-flex align-items-center mb-3"
        >
          <i className="ri-arrow-left-line me-1"></i>
          {t("products.back")}
        </button>
      </div>
      <div className="d-flex align-items-center mb-3">
        <div className="d-flex gap-3 align-items-center">
          <ImageContainer img={currentProduct?.productPictures ?? []} />
          {/* <GalleryCardPreview
            img={
              currentProduct?.productPictures[0]?.path ||
              "/images/jk-placeholder-image.jpg"
            }
          /> */}
          {/* <CustomImageHandler
            classes="avatar-lg rounded-circle me-2"
            path={currentProduct?.productPictures[1]?.path ?? ""}
            alt="User logo"
          /> */}
          <div>
            <h2>{currentProduct?.title}</h2>
            <p>{currentProduct?.eanCode}</p>
          </div>
        </div>
      </div>
      <BaseDataActions
        handleClose={handleClose}
        isImported={true}
        isEdit={true}
        currentTranslations={currentTranslations as any}
        setCurrentTranslations={setCurrentTranslations}
        currentProduct={currentProduct as IProductsList}
        setCurrentProduct={
          setCurrentProduct as React.Dispatch<
            SetStateAction<IProductsList | IProducts>
          >
        }
        changeHandler={changeHandler}
        handleSelectMainCategory={handleSelectMainCategory}
        files={files}
        setFiles={setFiles}
        documentFiles={documentFiles}
        setDocumentFiles={setDocumentFiles}
        videoFiles={videoFiles}
        setVideoFiles={setVideoFiles}
        handleSubmit={handleSubmit}
        categories={categories}
      />
    </>
    // </PageTemplate>
  );
};
